import { Injectable } from '@angular/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
import * as L from 'leaflet';
import { MapService, SiteTypeService } from 'src/api/services';
import { MapPin } from 'src/api/models';
import { ApplicationConfigService } from './application-config.service';
import { AzureAuthService } from './azure-auth.service';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { ApiConfiguration } from 'src/api/api-configuration';

@Injectable()
export class IconService {

  constructor(
    public app: ApplicationConfigService, 
    public map: MapService, 
    private siteType: SiteTypeService, 
    private readonly httpHandler: HttpBackend, 
    private security: AzureAuthService) {
        this.http = new HttpClient(httpHandler);
        this.openService = new MapService(new ApiConfiguration(), this.http);
  }

  private http: HttpClient;
  private openService : MapService;
  

  icons : string[] = [
    "fa fa-address-book", "fa fa-address-card", "fa fa-bandcamp", "fa fa-envelope-open", "fa fa-envelope-open-o", "fa fa-grav", "fa fa-snowflake-o", "fa fa-user-circle", "fa fa-user-circle-o", "fa fa-user-o",
    "fa fa-telegram", "fa fa-thermometer-empty", "fa fa-thermometer-full", "fa fa-thermometer-half", "fa fa-thermometer-quarter", "fa fa-thermometer-three-quarters",
    "fa fa-area-chart", "fa fa-bus", "fa fa-calculator", "fa fa-line-chart", "fa fa-pie-chart", "fa fa-plug", "fa fa-trash", "fa fa-bomb", "fa fa-building", "fa fa-car", "fa fa-child",
    "fa fa-database", "fa fa-plane", "fa fa-share-alt", "fa fa-sliders", "fa fa-space-shuttle", "fa fa-anchor", "fa fa-archive", "fa fa-bell", "fa fa-bell-o", "fa fa-bolt", "fa fa-bug",
    "fa fa-camera", "fa fa-check", "fa fa-cloud", "fa fa-coffee", "fa fa-cog", "fa fa-cogs", "fa fa-comment", "fa fa-compass", "fa fa-crosshairs", "fa fa-dashboard", "fa fa-envelope",
    "fa fa-exchange", "fa fa-exclama qtion", "fa fa-exclamation-circle", "fa fa-fighter-jet", "fa fa-fire", "fa fa-flag", "fa fa-flask", "fa fa-folder",
    "fa fa-folder-open", "fa fa-inbox", "fa fa-info", "fa fa-info-circle", "fa fa-male", "fa fa-map-marker", "fa fa-shield", "fa fa-signal", "fa fa-star", "fa fa-thumbs-up", "fa fa-thumbs-down",
    "fa fa-tint", "fa fa-wrench", "fa fa-heart", "fa fa-music", "fa fa-search", "fa fa-shopping-cart", "fa fa-users", "fa fa-video", "fa fa-wifi"
  ];

  getIcons() {
    return this.icons;
  }

  getPins(onComplete) {
    if (this.pins == null){
      if (!this.security.isAuthenticated()){
        /*this.pins = {};
        this.pinsById = {};

        // Add default Leaflet marker
        const iconDefault = L.icon({
          iconUrl: 'assets/pins/marker-icon-2x-blue.png',
          shadowUrl: 'assets/marker-shadow.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41]
        });
        this.pins['default'] = iconDefault
        this.pins['blueSelected'] = iconDefault;
        this.pins['blue'] = iconDefault;*/
        this.openService.MapGetMapPinsPublic().subscribe(s => {
          this.pinDetails = s;
          //const baseUrl = `https://${window.location.hostname}/`;
          this.pins = {};
          this.pinsById = {};

          // Add default Leaflet marker
          this.pins['default'] = new L.Icon.Default();

          for (let pin of s){
            if (pin.iconUrl == null){
              pin.iconUrl = this.windBarbUrl;
            }
            const icon = L.icon({
              iconRetinaUrl: pin.iconRetinaUrl,
              iconUrl: pin.iconUrl,
              shadowUrl: pin.shadowUrl,
              iconSize: pin.iconSize,
              iconAnchor: pin.iconAnchor,
              popupAnchor: pin.popupAnchor,
              tooltipAnchor: pin.tooltipAnchor,
              shadowSize: pin.shadowSize
            });
            this.pins[pin.name] = icon;
            this.pinsById[pin.id] = icon;
          }
          if (onComplete){
            onComplete(this.pins);
          }
        });
      }
      else {
        this.map.MapGetMapPins(this.app.customerId ?? 0).subscribe(s => {
          //this.pins = s;
          this.pinDetails = s;
          //const baseUrl = `https://${window.location.hostname}/`;
          this.pins = {};
          this.pinsById = {};

          // Add default Leaflet marker
          this.pins['default'] = new L.Icon.Default();

          for (let pin of s){
            if (pin.iconUrl == null){
              pin.iconUrl = this.windBarbUrl;
            }
            const icon = L.icon({
              iconRetinaUrl: pin.iconRetinaUrl,
              iconUrl: pin.iconUrl,
              shadowUrl: pin.shadowUrl,
              iconSize: pin.iconSize,
              iconAnchor: pin.iconAnchor,
              popupAnchor: pin.popupAnchor,
              tooltipAnchor: pin.tooltipAnchor,
              shadowSize: pin.shadowSize
            });
            this.pins[pin.name] = icon;
            this.pinsById[pin.id] = icon;
          }
          if (onComplete){
            onComplete(this.pins);
          }
        });
      }
    }else{
      if (onComplete){
        onComplete(this.pins);
      }
    }
    return this.pins;
  }

  public getPinDetailById(id: number){
    var pin = this.pinDetails.find(p => p.id == id);
    return pin;
  }

  public getPinById(id: number){
    var pin = this.pinsById[id];
    return pin;
  }

  public getPinIconById(id: number){
    var pin = this.pinDetails.find(p => p.id == id);
    if (pin.iconUrl == null){
      return this.shadowUrl;
    }
    return pin.iconUrl;
  }


  windBarbUrl : string = 'assets/icons/wind-barb.png';
  shadowUrl : string = 'assets/marker-shadow.png';
  public pinDetails: MapPin[];
  public pins: { [key: string]: L.icon };
  public pinsById: { [key: number]: L.icon };



}
